import React, { useEffect, useState, Fragment, useRef } from "react";
import { SessionIgnoreReportTableContent } from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {

        const searchData = this.props.searchData;
        const contentRowNames = this.props.rowNames;
        const reportData = this.props.reportData;

        return (
            <div>
                <h3 className="pr-2"><center><u>Session Ignore Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Esate: </b> {searchData.estate}</div>
                    <div className="col"><b>From Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                    <div className="col"><b>Division: </b> {searchData.collectionPoint === undefined ? "All Divisions" : searchData.collectionPoint}</div>
                    <div className="col"><b>Status: </b> {searchData.status === "0" ? "All Status" : searchData.status === "2" ? "Approved" : "Rejected"}</div>
                </div>
                <div className="table-responsive row-top-gap">
                    <table id="blockWeighment" className="display dataTable no-footer">
                        <thead>
                            <tr>
                                <th>Division</th>
                                <th>Date</th>
                                <th>Emp Name</th>
                                <th>Reg No</th>
                                <th>Reason</th>
                                <th>Reject Reason</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <SessionIgnoreReportTableContent
                                data={reportData}
                                contentRowNames={contentRowNames}
                                hasEdit={false}
                            />
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}